@if (withAbsoluteWrapper) {
  <div class="loading-button-wrapper">
    <ng-container [ngTemplateOutlet]="spinnerTemplate"></ng-container>
  </div>
} @else {
  <mat-spinner [diameter]="diameter" />
}

<ng-template #spinnerTemplate>
  <mat-spinner [diameter]="diameter" />
</ng-template>
